import mapLegendImage from "../map-legend.png";

export default class LegendControl {
  constructor(options = {}) {
    this.shown = true;
  }

  /**
   * Function which updates the DOM related code for the control
   */
  insertControls() {
    this.container = document.createElement("div");
    const elem = document.createElement("img");
    // after bundling, image data is received in Symbol object. The base64 representation
    // of image is present in `default` property of that object
    const src = typeof mapLegendImage === "string" ? mapLegendImage : mapLegendImage.default;
    elem.setAttribute("src", src);
    elem.setAttribute("width", "300");
    this.container.appendChild(elem);
    this.container.classList.add("map-legend");
  }

  /**
   * Function which is used to add custom control on map
   * @param {*} map Instance of map which is passed
   */
  onAdd(map) {
    this.map = map;
    this.insertControls();
    return this.container;
  }

  /**
   * Function which is used to remove custom control from the map
   */
  onRemove() {
    this.container.parentNode.removeChild(this.container);
    this.map = undefined;
  }

  /**
   * Function which is used to hide the control on the map
   */
  hide() {
    this.shown = false;
    this.container.classList.add("hide");
  }

  /**
   * Function which is used to show the control on the map
   */
  show() {
    this.shown = true;
    this.container.classList.remove("hide");
  }
}
